import { useMutation, useQueryClient } from "@tanstack/react-query";
import { restoreStudent as apiFn } from "../../api/apiStudents";
import { useSnackbar } from "notistack"; import getErrorMessageFromAxiosError from "../../utils/parseError";
export function useRestoreStudent() { const qc = useQueryClient(); const { enqueueSnackbar } = useSnackbar();
    const { mutate: restoreStudent, isPending: isRestore } = useMutation({ mutationFn: (id) => apiFn(id),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); qc.invalidateQueries({ queryKey: ["students"] }); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); } });
    return { restoreStudent, isRestore }; }
